export default __webpack_public_path__ + "static/media/prairiedogpng.7c8957b7.png";